export default "__VITE_ASSET__CXGSbOzD__"